import styles from './Arrow.module.scss';

export function Arrow(props: {
  disabled: boolean;
  isArrowDirectionLeft?: boolean;
  onClick: (e: any) => void;
}) {
  const disabled = props.disabled ? styles.arrowDisabled : '';
  return (
    <svg
      aria-disabled={props.disabled}
      aria-label={props.isArrowDirectionLeft ? 'Previous Slide' : 'Next Slide'}
      className={`${styles.arrow} ${props.isArrowDirectionLeft ? styles.leftArrow : styles.rightArrow} ${disabled}`}
      onClick={props.disabled ? undefined : props.onClick}
      onKeyDown={e => {
        if (!props.disabled && (e.key === 'Enter' || e.key === ' ')) {
          props.onClick(e);
        }
      }}
      preserveAspectRatio="xMidYMid meet"
      role="button"
      tabIndex={props.disabled ? -1 : 0}
      viewBox="-5 -5 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.isArrowDirectionLeft && (
        <path
          d="M12.8337 5.66672H3.52539L7.59206 1.60006C7.91706 1.27506 7.91706 0.741724 7.59206 0.416724C7.26706 0.0917236 6.74206 0.0917236 6.41706 0.416724L0.925391 5.90839C0.600391 6.23339 0.600391 6.75839 0.925391 7.08339L6.41706 12.5751C6.74206 12.9001 7.26706 12.9001 7.59206 12.5751C7.91706 12.2501 7.91706 11.7251 7.59206 11.4001L3.52539 7.33339H12.8337C13.2921 7.33339 13.6671 6.95839 13.6671 6.50006C13.6671 6.04172 13.2921 5.66672 12.8337 5.66672Z"
          fill="rgba(28, 73, 194, 1)"
        />
      )}
      {!props.isArrowDirectionLeft && (
        <path
          d="M1.16683 7.84334H10.4752L6.4085 11.91C6.0835 12.235 6.0835 12.7683 6.4085 13.0933C6.7335 13.4183 7.2585 13.4183 7.5835 13.0933L13.0752 7.60167C13.4002 7.27667 13.4002 6.75167 13.0752 6.42667L7.59183 0.926672C7.26683 0.601672 6.74183 0.601672 6.41683 0.926672C6.09183 1.25167 6.09183 1.77667 6.41683 2.10167L10.4752 6.17667H1.16683C0.708496 6.17667 0.333496 6.55167 0.333496 7.01001C0.333496 7.46834 0.708496 7.84334 1.16683 7.84334Z"
          fill="rgba(28, 73, 194, 1)"
        />
      )}
    </svg>
  );
}
